import {css, StyleSheet} from 'aphrodite';
import * as React from 'react';
import {useState} from 'react';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {ACTION_CATEGORY, COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import runModal from 'ui-library/runModal';
import CreateWorklistWithCollaboratorsModal from 'worklists/CreateWorklistWithCollaboratorsModal';
import {renderWorklistTypeOptions} from 'worklists/renderWorklistTypeOptions';
import {RefreshOptions} from 'worklists/WorklistActions';
import {WorklistType, worklistTypeDisplayName} from 'worklists/WorklistConstants';

export interface WorklistCreateButtonProps {
  buttonStyle: ButtonStyle;
  refreshOptions?: RefreshOptions;
}

export default function WorklistCreateButton(props: WorklistCreateButtonProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const analyticsModule = ANALYTICS_MODULE.WORKLISTS;

  const openCreateWorklistModal = (selectedType: WorklistType): void => {
    analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, analyticsModule, {
      modalType: 'create_worklist',
      worklistType: selectedType,
    });
    runModal(CreateWorklistWithCollaboratorsModal, {
      refreshOptions: props.refreshOptions,
      worklistType: selectedType,
    });
  };
  const getCreateWorklistOptionText = (worklistType: WorklistType): string =>
    `Create ${worklistTypeDisplayName(worklistType)} worklist`;
  return (
    <Dropdown
      className={css(styles.dropdown)}
      isOpen={isOpen}
      onToggle={(newIsOpen) => {
        setIsOpen(newIsOpen);
      }}
      menu={
        <Menu
          height={Menu.HEIGHTS.MEDIUM}
          width={Menu.WIDTHS.LARGE}
          onMouseLeave={() => {
            setIsOpen(false);
          }}
          dropLeft={true}
        >
          {renderWorklistTypeOptions({
            onSelectWorklistType: openCreateWorklistModal,
            getOptionText: getCreateWorklistOptionText,
          })}
        </Menu>
      }
    >
      <Tooltip title="New worklist" placement={TooltipPlacement.BOTTOM} container="body" disabled={false}>
        <Button
          onClick={() => {
            analytics.trackEventWithModule(
              {
                module: analyticsModule,
                action: 'clicked_create_worklist_button',
                actionCategory: ACTION_CATEGORY.READ,
              },
              analyticsModule,
              {}
            );
            setIsOpen(true);
          }}
          buttonStyle={props.buttonStyle}
          size={ButtonSize.SMALL}
          icon="compose"
          dataTestAttrs={{component: 'WorklistCreateButton', element: 'button'}}
        />
      </Tooltip>
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  dropdown: {
    marginTop: 1,
  },
});
